import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FileOperationsService {
  onSelect = new Subject();
  api: string = environment.baseUrl;
  currentQuestion: any = {};
  fileSaveComplete = new Subject();
  constructor(private http: HttpClient) {

  }

  getSaveStatus() {
    return this.fileSaveComplete;
  }

  updateSaveStatus() {
    this.fileSaveComplete.next('');
  }

  onSubmitFile(path: any) {
    this.onSelect.next(path)
  }

  getFileInfo(path: any) {
    return this.http.get(this.api + `fileupload/getFileContent/?path=${path}`)
  }

  createFolder(data: any, path: any) {
    return this.http.post(this.api + 'fileupload/creatfolder?path='+path, data)
  }

  postFile(fileToUpload: any, path: any) {
    const endpoint = this.api + 'fileupload/uploadfile/?path='+path;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    return this.http.post(endpoint, formData);
  }

  saveLink(url: string, path: string) {
    const fullPath = 'static' + path;
    const endpoint = this.api + 'fileupload/uploadfile/?path='+fullPath;
    try {
      // Replace special characters with underscore for filename
      const urlObj = new URL(url);
      const hostname = urlObj.hostname;
      // Get full path including query parameters
      const fullPath = urlObj.pathname + urlObj.search;
      const safeFileName = fullPath.replace(/[^a-zA-Z0-9]/g, '_');
      const filename = `link_${hostname}${safeFileName}.txt`;
      // Create a Blob from the URL string to simulate a file
      const blob = new Blob([url]);
      const formData = new FormData();
      formData.append('file', blob, filename);
      return this.http.post(endpoint, formData);
    } catch (error) {
      throw new Error('Error saving link');
    }
  }

  // getUrlVideo(value:string): Observable<any> {
  //   let url = this.api + 'static' + value;
  //   return this.http.get(url, { responseType: "text" });
  // }

  getVideoEmbedData(value: string): Observable<any> {
    const youtubeUrl = value.trim();
    const embedUrl = `${window.location.protocol}//www.youtube.com/oembed?url=${encodeURIComponent(youtubeUrl)}`;
    return this.http.get(embedUrl, { responseType: "json" }).pipe(
      map(embedData => ({
        ...embedData,
        youtubeUrl
      }))
    );
  }
}
